import { useEffect, useState } from "react";
import { NavLink, useParams } from "react-router-dom";
import { toast } from "sonner";
import { cachedGet, errMsg } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Loading, RagBadge } from "@/components/app/bits";
import OverviewTab from "./OverviewTab";
import ChecksheetsTab from "./ChecksheetsTab";
import PunchTab from "./PunchTab";
import MilestonesTab from "./MilestonesTab";
import P6Tab from "./P6Tab";
import DataTab from "./DataTab";

const TABS = [["overview", "Overview", OverviewTab], ["checksheets", "Checksheets", ChecksheetsTab], ["punch", "Punch list", PunchTab],
  ["milestones", "Milestones", MilestonesTab], ["p6", "P6 programme", P6Tab], ["data", "Import / export", DataTab]];

export default function ProjectPage() {
  const { pid, tab = "overview" } = useParams();
  const { me } = useAuth();
  const [project, setProject] = useState(null);
  useEffect(() => { cachedGet(`/projects/${pid}`).then((r) => setProject(r.data)).catch((e) => toast.error(errMsg(e))); }, [pid, me.active_org_id]);
  if (!project) return <Loading />;
  const Current = (TABS.find((t) => t[0] === tab) || TABS[0])[2];
  return (
    <div data-testid="project-page">
      <div className="flex flex-col md:flex-row md:items-end justify-between gap-3 mb-5">
        <div>
          <p className="eyebrow mb-1">{project.code}</p>
          <h1 className="text-3xl md:text-4xl font-bold tracking-tight text-slate-50" data-testid="project-name">{project.name}</h1>
          {project.description && <p className="text-sm text-slate-400 mt-1 max-w-2xl">{project.description}</p>}
        </div>
        {project.key_milestone && (
          <div className="flex items-center gap-3 text-sm"><span className="text-slate-400">{project.key_milestone.name}</span><RagBadge rag={project.rag} testid="project-rag" /></div>
        )}
      </div>
      <nav className="flex gap-1 overflow-x-auto border-b border-[#1E2D4A] mb-6 -mx-4 px-4 md:mx-0 md:px-0" data-testid="project-tabs">
        {TABS.map(([key, label]) => (
          <NavLink key={key} to={`/app/projects/${pid}/${key}`} data-testid={`tab-${key}`}
            className={() => `px-4 py-2.5 text-sm whitespace-nowrap border-b-2 -mb-px transition-colors ${tab === key ? "border-amber-500 text-amber-400" : "border-transparent text-slate-400 hover:text-slate-100"}`}>{label}</NavLink>
        ))}
      </nav>
      <Current project={project} />
    </div>
  );
}
